import { isOrderTypeTakeoverEnabled } from './is-order-type-takeover-enabled';

/**
 * Minimal shape needed to evaluate the takeover gate. `storeSettings` drives
 * the admin setting.
 */
type DispensaryWithTakeoverGate = {
  id?: string | null;
  storeSettings?: {
    enableOrderTypeTakeoverModal?: boolean | null;
  } | null;
} | null;

/**
 * Single source of truth for whether the order-type takeover is active for a
 * dispensary. Driven by the admin-controlled `enableOrderTypeTakeoverModal`
 * store setting (Settings > Menu). Defaults to `false` when unset.
 *
 * Because the setting arrives on the dispensary GraphQL payload (not client-side
 * context-flag evaluation), it isn't subject to the SSR-bootstrap context race
 * that affected the original consumer flag (ECOMM-11202).
 *
 * Kept as a hook so call sites stay stable and the gate has one entry point.
 */
export function useIsOrderTypeTakeoverEnabled(dispensary: DispensaryWithTakeoverGate | undefined): boolean {
  return isOrderTypeTakeoverEnabled(dispensary);
}
